/* ==========================================================================
   Surkhab theme.js — vanilla JS, no build step, no dependencies
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Utilities
     ------------------------------------------------------------------ */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function formatMoney(cents, format) {
    if (typeof cents !== 'number') cents = parseFloat(cents) || 0;
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var formatted = parts.join('.');
    if (!format) {
      // Prefer the shopper's active presentment currency symbol (set from Liquid's
      // cart.currency, which is correctly currency-aware) over Shopify.money_format,
      // which always reflects the shop's base currency regardless of what the
      // customer is actually seeing.
      var symbol = (window.Surkhab && window.Surkhab.currency && window.Surkhab.currency.symbol) || '$';
      format = symbol + '{{amount}}';
    }
    return format.replace('{{amount}}', formatted);
  }
  window.Surkhab = window.Surkhab || {};
  window.Surkhab.formatMoney = formatMoney;

  /* ------------------------------------------------------------------
     Cart Drawer (AJAX Cart API)
     ------------------------------------------------------------------ */
  var CartDrawer = {
    el: null,
    overlay: null,
    init: function () {
      this.el = qs('[data-cart-drawer]');
      this.overlay = qs('[data-cart-overlay]');
      if (!this.el) return;

      qsa('[data-cart-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          CartDrawer.open();
        });
      });
      qsa('[data-cart-close]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          CartDrawer.close();
        });
      });
      if (this.overlay) {
        this.overlay.addEventListener('click', function () { CartDrawer.close(); });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') CartDrawer.close();
      });

      this.el.addEventListener('click', function (e) {
        var incBtn = e.target.closest('[data-qty-increase]');
        var decBtn = e.target.closest('[data-qty-decrease]');
        var removeBtn = e.target.closest('[data-cart-remove]');
        if (incBtn) {
          var wrap = incBtn.closest('[data-cart-line]');
          var input = qs('[data-qty-input]', wrap);
          input.value = parseInt(input.value, 10) + 1;
          CartDrawer.updateLine(wrap.dataset.key, input.value);
        } else if (decBtn) {
          var wrap2 = decBtn.closest('[data-cart-line]');
          var input2 = qs('[data-qty-input]', wrap2);
          var newVal = Math.max(0, parseInt(input2.value, 10) - 1);
          input2.value = newVal;
          CartDrawer.updateLine(wrap2.dataset.key, newVal);
        } else if (removeBtn) {
          var wrap3 = removeBtn.closest('[data-cart-line]');
          CartDrawer.updateLine(wrap3.dataset.key, 0);
        }
      });

      // Add-to-cart forms anywhere on the page (product cards, PDP)
      document.body.addEventListener('submit', function (e) {
        var form = e.target;
        if (form.matches('[data-atc-form]')) {
          e.preventDefault();
          var submitter = e.submitter;
          var buyNow = !!(submitter && submitter.hasAttribute('data-buy-now'));
          CartDrawer.addFromForm(form, submitter, buyNow);
        } else if (form.matches('[data-fbt-form]')) {
          e.preventDefault();
          CartDrawer.addBundleFromForm(form);
        }
      });
    },
    open: function () {
      if (!this.el) return;
      this.el.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      MegaMenu.close();
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    },
    addFromForm: function (form, submitBtn, redirectToCheckout) {
      var formData = new FormData(form);
      submitBtn = submitBtn || qs('[type="submit"]', form);
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.originalText = submitBtn.textContent; submitBtn.textContent = redirectToCheckout ? 'Processing…' : 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            throw new Error(data.description || 'Could not add to cart');
          }
          if (redirectToCheckout) return null;
          return CartDrawer.refresh();
        })
        .then(function () {
          if (redirectToCheckout) {
            window.location.href = '/checkout';
            return;
          }
          CartDrawer.open();
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText; }
        })
        .catch(function (err) {
          console.error(err);
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText; }
          alert(err.message || 'Sorry, that item could not be added to your cart.');
        });
    },
    addBundleFromForm: function (form) {
      var formData = new FormData(form);
      var itemsMap = {};
      formData.forEach(function (value, key) {
        var match = key.match(/^items\[(\d+)\]\[(\w+)\]$/);
        if (match) {
          itemsMap[match[1]] = itemsMap[match[1]] || {};
          itemsMap[match[1]][match[2]] = match[2] === 'id' || match[2] === 'quantity' ? parseInt(value, 10) : value;
        }
      });
      var items = Object.keys(itemsMap).map(function (k) { return itemsMap[k]; });
      var submitBtn = qs('[type="submit"]', form);
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.originalText = submitBtn.textContent; submitBtn.textContent = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || 'Could not add bundle to cart');
          return CartDrawer.refresh();
        })
        .then(function () {
          CartDrawer.open();
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText; }
        })
        .catch(function (err) {
          console.error(err);
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText; }
          alert(err.message || 'Sorry, that bundle could not be added to your cart.');
        });
    },
    updateLine: function (key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function () { return CartDrawer.refresh(); })
        .catch(function (err) { console.error(err); });
    },
    refresh: function () {
      return fetch('/?section_id=cart-drawer')
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newDrawer = qs('[data-cart-drawer-section]', doc);
          var oldDrawer = qs('[data-cart-drawer-section]');
          if (newDrawer && oldDrawer) {
            oldDrawer.innerHTML = newDrawer.innerHTML;
          }
          CartDrawer.el = qs('[data-cart-drawer]');
          CartDrawer.el && CartDrawer.el.classList.add('is-open');
          if (CartDrawer.overlay) CartDrawer.overlay.classList.add('is-open');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          qsa('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? '' : 'none';
          });
        });
    }
  };

  /* ------------------------------------------------------------------
     Mega menu + nav toggle
     ------------------------------------------------------------------ */
  var MegaMenu = {
    el: null,
    init: function () {
      this.el = qs('[data-mega-menu]');
      var toggle = qs('[data-mega-toggle]');
      if (!toggle || !this.el) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        MegaMenu.toggleOpen();
      });
      document.addEventListener('click', function (e) {
        if (MegaMenu.el && MegaMenu.el.classList.contains('is-open') &&
          !MegaMenu.el.contains(e.target) && !toggle.contains(e.target)) {
          MegaMenu.close();
        }
      });
    },
    toggleOpen: function () {
      if (!this.el) return;
      this.el.classList.toggle('is-open');
      if (this.el.classList.contains('is-open')) CartDrawer.close();
    },
    close: function () {
      if (this.el) this.el.classList.remove('is-open');
    }
  };

  /* ------------------------------------------------------------------
     Predictive search
     ------------------------------------------------------------------ */
  var PredictiveSearch = {
    init: function () {
      var input = qs('[data-predictive-search-input]');
      var results = qs('[data-predictive-search-results]');
      if (!input || !results) return;
      var timer;
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var term = input.value.trim();
        if (term.length < 2) {
          results.classList.remove('is-open');
          results.innerHTML = '';
          return;
        }
        timer = setTimeout(function () { PredictiveSearch.fetch(term, results); }, 250);
      });
      document.addEventListener('click', function (e) {
        if (!results.contains(e.target) && e.target !== input) {
          results.classList.remove('is-open');
        }
      });
    },
    fetch: function (term, results) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,vendor')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            results.innerHTML = '<div class="predictive-search-empty">No products found for "' + term + '"</div>';
          } else {
            results.innerHTML = products.map(function (p) {
              var img = p.image ? '<img src="' + p.image + '" alt="" width="44" height="44" loading="lazy">' : '';
              // suggest.json returns price as a plain decimal string (e.g. "13.00"),
              // not cents and not currency-formatted — route it through formatMoney.
              var price = formatMoney(Math.round(parseFloat(p.price) * 100));
              return '<a class="predictive-search-results__item" href="' + p.url + '">' + img +
                '<span class="predictive-search-results__name">' + p.title + '</span>' +
                '<span class="predictive-search-results__price" style="margin-left:auto">' + price + '</span></a>';
            }).join('');
          }
          results.classList.add('is-open');
        })
        .catch(function (err) { console.error(err); });
    }
  };

  /* ------------------------------------------------------------------
     Accordions (FAQ, product questions)
     ------------------------------------------------------------------ */
  var Accordion = {
    init: function (root) {
      qsa('[data-accordion]', root).forEach(function (accordion) {
        var singleOpen = accordion.dataset.accordionSingle !== 'false';
        qsa('[data-accordion-item]', accordion).forEach(function (item) {
          var trigger = qs('[data-accordion-trigger]', item);
          var icon = qs('[data-accordion-icon]', item);
          if (!trigger) return;
          trigger.addEventListener('click', function () {
            var isOpen = item.classList.contains('is-open');
            if (singleOpen) {
              qsa('[data-accordion-item]', accordion).forEach(function (other) {
                other.classList.remove('is-open');
                var otherIcon = qs('[data-accordion-icon]', other);
                if (otherIcon) otherIcon.textContent = '+';
              });
            }
            if (!isOpen) {
              item.classList.add('is-open');
              if (icon) icon.textContent = '−';
            } else {
              item.classList.remove('is-open');
              if (icon) icon.textContent = '+';
            }
          });
        });
      });
    }
  };

  /* ------------------------------------------------------------------
     Flash sale countdown
     ------------------------------------------------------------------ */
  var Countdown = {
    init: function () {
      qsa('[data-countdown]').forEach(function (el) {
        var end = new Date(el.dataset.countdown).getTime();
        if (isNaN(end)) return;
        var hh = qs('[data-countdown-hh]', el);
        var mm = qs('[data-countdown-mm]', el);
        var ss = qs('[data-countdown-ss]', el);
        function tick() {
          var now = new Date().getTime();
          var diff = Math.max(0, Math.floor((end - now) / 1000));
          var h = Math.floor(diff / 3600);
          var m = Math.floor((diff % 3600) / 60);
          var s = diff % 60;
          var pad = function (n) { return String(n).padStart(2, '0'); };
          if (hh) hh.textContent = pad(h);
          if (mm) mm.textContent = pad(m);
          if (ss) ss.textContent = pad(s);
          if (diff <= 0) clearInterval(interval);
        }
        tick();
        var interval = setInterval(tick, 1000);
      });
    }
  };

  /* ------------------------------------------------------------------
     PDP gallery — thumbnail swap + hover zoom
     ------------------------------------------------------------------ */
  var Gallery = {
    init: function () {
      var main = qs('[data-gallery-main]');
      if (!main) return;
      var mainImg = qs('img', main);
      qsa('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          qsa('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          var full = thumb.dataset.fullSrc;
          var thumbImg = qs('img', thumb);
          if (mainImg && full) {
            mainImg.src = full;
            mainImg.srcset = '';
            mainImg.alt = thumbImg ? thumbImg.alt : mainImg.alt;
          }
        });
      });
      main.addEventListener('mousemove', function (e) {
        if (window.innerWidth < 860) return;
        var rect = main.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        if (mainImg) mainImg.style.transformOrigin = x + '% ' + y + '%';
        main.classList.add('is-zoomed');
      });
      main.addEventListener('mouseleave', function () {
        main.classList.remove('is-zoomed');
        if (mainImg) mainImg.style.transformOrigin = 'center';
      });
    }
  };

  /* ------------------------------------------------------------------
     PDP variant picker
     ------------------------------------------------------------------ */
  var VariantPicker = {
    init: function () {
      qsa('[data-variant-picker]').forEach(function (root) {
        var variantsJson = root.dataset.variants;
        if (!variantsJson) return;
        var variants;
        try { variants = JSON.parse(variantsJson); } catch (e) { return; }

        var selectedOptions = {};
        qsa('[data-option-index]', root).forEach(function (group) {
          var selected = qs('.is-selected', group) || qs('[data-option-value]', group);
          if (selected) selectedOptions[group.dataset.optionIndex] = selected.dataset.optionValue;
        });

        function findVariant() {
          return variants.find(function (v) {
            return Object.keys(selectedOptions).every(function (idx) {
              return v.options[idx] === selectedOptions[idx];
            });
          });
        }

        function updateUI() {
          var variant = findVariant();
          var priceEl = qs('[data-variant-price]', root.closest('[data-pdp-root]') || document);
          var compareEl = qs('[data-variant-compare]', root.closest('[data-pdp-root]') || document);
          var atcBtn = qs('[data-atc-submit]');
          var buyNowBtn = qs('[data-buy-now]');
          var idInput = qs('[data-variant-id-input]');
          var stockEl = qs('[data-variant-stock]');
          var skuEl = qs('[data-variant-sku]');

          qsa('[data-option-value]', root).forEach(function (btn) {
            var group = btn.closest('[data-option-index]');
            var idx = group.dataset.optionIndex;
            btn.classList.toggle('is-selected', btn.dataset.optionValue === selectedOptions[idx]);
          });
          qsa('[data-option-selected-label]', root).forEach(function (label) {
            var idx = label.dataset.optionSelectedLabel;
            label.textContent = selectedOptions[idx] || '';
          });

          if (idInput) idInput.value = variant ? variant.id : '';
          if (atcBtn) atcBtn.disabled = !variant || !variant.available;
          if (buyNowBtn) buyNowBtn.disabled = !variant || !variant.available;

          if (variant) {
            if (priceEl) priceEl.textContent = formatMoney(variant.price);
            if (compareEl) {
              if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                compareEl.textContent = formatMoney(variant.compare_at_price);
                compareEl.style.display = '';
              } else {
                compareEl.style.display = 'none';
              }
            }
            if (stockEl) {
              stockEl.textContent = variant.available ? '✓ In stock' : 'Out of stock';
              stockEl.classList.toggle('pdp-info__stock--out', !variant.available);
            }
            if (skuEl) skuEl.textContent = variant.sku || '';
            root.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant: variant } }));
          }
          QtyStepper.recalcTotals();
        }

        root.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-option-value]');
          if (!btn || btn.disabled) return;
          var group = btn.closest('[data-option-index]');
          selectedOptions[group.dataset.optionIndex] = btn.dataset.optionValue;
          updateUI();
        });

        updateUI();
      });
    }
  };

  /* ------------------------------------------------------------------
     Qty stepper (PDP + cart drawer use shared markup)
     ------------------------------------------------------------------ */
  var QtyStepper = {
    unitPrice: 0,
    init: function () {
      qsa('[data-pdp-qty]').forEach(function (wrap) {
        var input = qs('[data-qty-input]', wrap);
        var inc = qs('[data-qty-increase]', wrap);
        var dec = qs('[data-qty-decrease]', wrap);
        if (inc) inc.addEventListener('click', function () {
          input.value = Math.min(9, parseInt(input.value, 10) + 1);
          QtyStepper.recalcTotals();
        });
        if (dec) dec.addEventListener('click', function () {
          input.value = Math.max(1, parseInt(input.value, 10) - 1);
          QtyStepper.recalcTotals();
        });
        if (input) input.addEventListener('change', function () {
          var v = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, Math.min(9, v));
          QtyStepper.recalcTotals();
        });
      });
    },
    recalcTotals: function () {
      var priceEl = qs('[data-variant-price]');
      var qtyInput = qs('[data-pdp-qty] [data-qty-input]');
      if (!priceEl || !qtyInput) return;
      var priceCents = parseFloat((priceEl.dataset.priceCents)) || null;
      // fall back to parsing displayed money text if data attribute unavailable
      qsa('[data-atc-total]').forEach(function (el) {
        var base = parseFloat(qs('[data-variant-price]').dataset.priceCents || '0');
        var qty = parseInt(qtyInput.value, 10) || 1;
        el.textContent = formatMoney(base * qty);
      });
      qsa('[data-sticky-total]').forEach(function (el) {
        var base = parseFloat(qs('[data-variant-price]').dataset.priceCents || '0');
        var qty = parseInt(qtyInput.value, 10) || 1;
        el.textContent = formatMoney(base * qty);
      });
    }
  };

  /* ------------------------------------------------------------------
     Grid / list toggle (Collection page)
     ------------------------------------------------------------------ */
  var ViewToggle = {
    init: function () {
      var gridBtn = qs('[data-view-grid]');
      var listBtn = qs('[data-view-list]');
      var gridEl = qs('[data-product-grid]');
      var listEl = qs('[data-product-list]');
      if (!gridBtn || !listBtn) return;
      var stored = localStorage.getItem('surkhab:collectionView') || 'grid';
      apply(stored);
      gridBtn.addEventListener('click', function () { apply('grid'); localStorage.setItem('surkhab:collectionView', 'grid'); });
      listBtn.addEventListener('click', function () { apply('list'); localStorage.setItem('surkhab:collectionView', 'list'); });
      function apply(mode) {
        gridBtn.classList.toggle('is-active', mode === 'grid');
        listBtn.classList.toggle('is-active', mode === 'list');
        if (gridEl) gridEl.style.display = mode === 'grid' ? '' : 'none';
        if (listEl) listEl.style.display = mode === 'list' ? '' : 'none';
      }
    }
  };

  /* ------------------------------------------------------------------
     Sort select (Collection page) — re-navigates with sort_by param
     ------------------------------------------------------------------ */
  var SortSelect = {
    init: function () {
      var sel = qs('[data-sort-select]');
      if (!sel) return;
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        window.location.href = url.toString();
      });
    }
  };

  /* ------------------------------------------------------------------
     Filter checkboxes — visual state only (native form submits reload)
     ------------------------------------------------------------------ */
  var Filters = {
    init: function () {
      qsa('[data-filter-checkbox]').forEach(function (box) {
        var input = qs('input', box);
        var mark = qs('[data-filter-box]', box);
        if (!input) return;
        var sync = function () {
          if (mark) mark.classList.toggle('is-checked', input.checked);
          if (mark) mark.textContent = input.checked ? '✓' : '';
        };
        input.addEventListener('change', function () {
          sync();
          box.closest('form') && box.closest('form').submit();
        });
        sync();
      });
      var clearBtn = qs('[data-filter-clear]');
      if (clearBtn) {
        clearBtn.addEventListener('click', function (e) {
          e.preventDefault();
          window.location.href = clearBtn.dataset.filterClear;
        });
      }
    }
  };

  /* ------------------------------------------------------------------
     Wishlist (localStorage) — heart toggle on product cards + wishlist page
     ------------------------------------------------------------------ */
  var Wishlist = {
    KEY: 'surkhab:wishlist',
    get: function () {
      try { return JSON.parse(localStorage.getItem(this.KEY) || '[]'); } catch (e) { return []; }
    },
    save: function (list) {
      localStorage.setItem(this.KEY, JSON.stringify(list));
    },
    has: function (handle) {
      return this.get().indexOf(handle) !== -1;
    },
    toggle: function (handle) {
      var list = this.get();
      var idx = list.indexOf(handle);
      if (idx === -1) { list.unshift(handle); } else { list.splice(idx, 1); }
      this.save(list);
      return idx === -1;
    },
    handleFromCard: function (card) {
      var link = qs('.product-card__link-media', card);
      if (!link) return null;
      var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      return match ? match[1] : null;
    },
    syncButton: function (btn, handle) {
      var active = this.has(handle);
      btn.classList.toggle('is-active', active);
      btn.textContent = active ? '♥' : '♡';
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    },
    updateCount: function () {
      var count = this.get().length;
      qsa('[data-wishlist-count]').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
    },
    init: function () {
      var self = this;
      qsa('[data-product-card]').forEach(function (card) {
        var btn = qs('[data-wishlist-toggle]', card);
        var handle = self.handleFromCard(card);
        if (!btn || !handle) return;
        self.syncButton(btn, handle);
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.toggle(handle);
          self.syncButton(btn, handle);
          self.updateCount();
        });
      });
      this.updateCount();
    },
    renderPage: function () {
      var grid = qs('[data-wishlist-grid]');
      var empty = qs('[data-wishlist-empty]');
      if (!grid) return;
      var self = this;
      var list = this.get();
      if (!list.length) {
        if (empty) empty.hidden = false;
        return;
      }
      if (empty) empty.hidden = true;
      list.forEach(function (handle) {
        fetch('/products/' + handle + '.js')
          .then(function (res) { if (!res.ok) throw new Error('not found'); return res.json(); })
          .then(function (product) {
            var img = product.featured_image || (product.images && product.images[0]) || '';
            var price = formatMoney(product.price);
            var card = document.createElement('div');
            card.className = 'product-card';
            card.innerHTML =
              '<a href="/products/' + product.handle + '" class="product-card__link-media" style="text-decoration:none;color:inherit;display:block">' +
                '<div class="product-card__media placeholder-stripe">' + (img ? '<img src="' + img + '" width="220" height="220" alt="" loading="lazy">' : '') + '</div>' +
                '<div class="product-card__body">' +
                  '<div class="product-card__name">' + product.title + '</div>' +
                  '<div class="product-card__price-row"><span class="product-card__price">' + price + '</span></div>' +
                '</div>' +
              '</a>' +
              '<button type="button" class="product-card__wishlist is-active" data-wishlist-toggle aria-label="Remove from wishlist">♥</button>';
            grid.appendChild(card);
            var btn = qs('[data-wishlist-toggle]', card);
            btn.addEventListener('click', function (e) {
              e.preventDefault();
              self.toggle(handle);
              card.remove();
              self.updateCount();
              if (!grid.children.length && empty) empty.hidden = false;
            });
          })
          .catch(function () { /* product may be gone */ });
      });
    }
  };

  /* ------------------------------------------------------------------
     Recently viewed (localStorage)
     ------------------------------------------------------------------ */
  var RecentlyViewed = {
    KEY: 'surkhab:recentlyViewed',
    MAX: 12,
    init: function () {
      var pdpRoot = qs('[data-pdp-root]');
      if (pdpRoot && pdpRoot.dataset.productHandle) {
        this.record(pdpRoot.dataset.productHandle);
      }
      this.render();
    },
    record: function (handle) {
      try {
        var list = JSON.parse(localStorage.getItem(this.KEY) || '[]');
        list = list.filter(function (h) { return h !== handle; });
        list.unshift(handle);
        list = list.slice(0, this.MAX);
        localStorage.setItem(this.KEY, JSON.stringify(list));
      } catch (e) { /* ignore */ }
    },
    render: function () {
      var section = qs('[data-recently-viewed]');
      if (!section) return;
      var currentHandle = (qs('[data-pdp-root]') || {}).dataset ? qs('[data-pdp-root]').dataset.productHandle : null;
      var list;
      try { list = JSON.parse(localStorage.getItem(this.KEY) || '[]'); } catch (e) { list = []; }
      list = list.filter(function (h) { return h !== currentHandle; }).slice(0, 6);
      if (!list.length) {
        section.classList.remove('has-items');
        return;
      }
      var grid = qs('[data-recently-viewed-grid]', section);
      if (!grid) return;
      grid.innerHTML = '';
      var remaining = list.length;
      list.forEach(function (handle) {
        fetch('/products/' + handle + '.js')
          .then(function (res) { if (!res.ok) throw new Error('not found'); return res.json(); })
          .then(function (product) {
            var img = product.featured_image || (product.images && product.images[0]) || '';
            var price = formatMoney(product.price);
            var card = document.createElement('a');
            card.className = 'recent-card';
            card.href = '/products/' + product.handle;
            card.innerHTML =
              '<span class="recent-card__thumb">' + (img ? '<img src="' + img + '" width="52" height="52" alt="" loading="lazy">' : '') + '</span>' +
              '<span><span class="recent-card__name">' + product.title + '</span>' +
              '<span class="recent-card__price">' + price + '</span></span>';
            grid.appendChild(card);
          })
          .catch(function () { /* product may be gone */ })
          .finally(function () {
            remaining -= 1;
            if (grid.children.length > 0) section.classList.add('has-items');
          });
      });
    }
  };

  /* ------------------------------------------------------------------
     Product recommendations (Shopify recommendations API)
     ------------------------------------------------------------------ */
  var Recommendations = {
    init: function () {
      var el = qs('[data-related-products]');
      if (!el || !el.dataset.url) return;
      fetch(el.dataset.url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = qs('[data-related-products-grid]', doc);
          var oldGrid = qs('[data-related-products-grid]', el);
          if (newGrid && oldGrid && newGrid.children.length) {
            oldGrid.innerHTML = newGrid.innerHTML;
          }
        })
        .catch(function (err) { console.error(err); });
    }
  };

  /* ------------------------------------------------------------------
     Sticky add-to-cart bar (PDP)
     ------------------------------------------------------------------ */
  var StickyBar = {
    init: function () {
      var bar = qs('[data-sticky-bar]');
      var trigger = qs('[data-pdp-cta-row]');
      if (!bar || !trigger) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      io.observe(trigger);
    }
  };

  /* ------------------------------------------------------------------
     Video modal
     ------------------------------------------------------------------ */
  var VideoModal = {
    init: function () {
      var trigger = qs('[data-video-trigger]');
      var modal = qs('[data-video-modal]');
      if (!trigger || !modal) return;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        modal.classList.add('is-open');
        var iframe = qs('iframe', modal);
        if (iframe && iframe.dataset.src && !iframe.src) iframe.src = iframe.dataset.src;
      });
      qsa('[data-video-close]', modal).forEach(function (btn) {
        btn.addEventListener('click', function () { modal.classList.remove('is-open'); });
      });
      modal.addEventListener('click', function (e) {
        if (e.target === modal) modal.classList.remove('is-open');
      });
    }
  };

  /* ------------------------------------------------------------------
     Locale/currency form auto-submit (Shopify localization form)
     ------------------------------------------------------------------ */
  var LocaleForm = {
    init: function () {
      qsa('[data-locale-select]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          sel.closest('form').submit();
        });
      });
    }
  };

  /* ------------------------------------------------------------------
     Cart page — standalone /cart quantity steppers (drawer's stepper
     handler only covers the slide-out drawer, not this full page)
     ------------------------------------------------------------------ */
  var CartPage = {
    init: function () {
      var form = qs('#CartForm');
      if (!form) return;
      form.addEventListener('click', function (e) {
        var incBtn = e.target.closest('[data-qty-increase]');
        var decBtn = e.target.closest('[data-qty-decrease]');
        if (!incBtn && !decBtn) return;
        e.preventDefault();
        var line = (incBtn || decBtn).closest('[data-cart-line]');
        var input = line && qs('[data-qty-input]', line);
        if (!input) return;
        var value = parseInt(input.value, 10) || 0;
        input.value = incBtn ? value + 1 : Math.max(0, value - 1);
        form.requestSubmit();
      });
    }
  };

  /* ------------------------------------------------------------------
     Init
     ------------------------------------------------------------------ */
  document.addEventListener('DOMContentLoaded', function () {
    CartDrawer.init();
    MegaMenu.init();
    PredictiveSearch.init();
    Accordion.init(document);
    Countdown.init();
    Gallery.init();
    VariantPicker.init();
    QtyStepper.init();
    ViewToggle.init();
    SortSelect.init();
    Filters.init();
    RecentlyViewed.init();
    Recommendations.init();
    StickyBar.init();
    VideoModal.init();
    LocaleForm.init();
    CartPage.init();
    Wishlist.init();
    Wishlist.renderPage();
  });
})();
